import React from 'react';
import './_commonjsHelpers-df867233.js';
import { P as PropTypes } from './index-6a8f8095.js';
import styled, { css } from 'styled-components';
import { _ as _taggedTemplateLiteral, a as _objectWithoutProperties, b as _extends } from './_rollupPluginBabelHelpers-b3c9b1cd.js';
import './_baseEach-3b97c1a8.js';
import './isArray-a3f14da2.js';
import './_Map-9acd9da3.js';
import './get-f58f8821.js';
import './_baseIteratee-651c88ed.js';
import './index-7f6959fc.js';
import './index-ae4b14fb.js';
import './head-b3f271d9.js';
import './map-651e82c0.js';
import './join-15b17329.js';
import './noop-d79f8d84.js';
import './isEmpty-9e4c9724.js';
import './wrapMediaQuery-d94fbf55.js';
import { Text } from './Typographies.js';
import './index-f96168ba.js';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ::placeholder {\n    color: ", ";\n  }\n\n  &:focus {\n    outline: none;\n    border-color: ", ";\n    box-shadow: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var borders = css(["border:", " solid ", ";border-radius:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.components.textarea.textarea.borders.width;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.components.textarea.textarea.colors.border;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.components.textarea.textarea.borders.radius;
});
var colors = css(["color:", ";caret-color:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.components.textarea.textarea.colors.text;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.components.textarea.textarea.colors.caret;
});
var spaces = css(["padding:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.components.textarea.textarea.spaces.padding;
});
var sizes = css(["height:", ";width:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.components.textarea.textarea.sizes.height;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.components.textarea.textarea.sizes.width;
});
var StyledTextArea = styled(Text.withComponent('textarea'))(_templateObject(), borders, colors, spaces, sizes, function (_ref9) {
  var theme = _ref9.theme;
  return theme.components.textarea.textarea.colors.placeholder;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.components.textarea.textarea.colors.borderFocus;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.components.textarea.textarea.boxShadows.boxShadowFocus;
});

function _templateObject$1() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * A textarea.
 *
 */

var TextArea = function TextArea(_ref) {
  var id = _ref.id,
      name = _ref.name,
      onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, ["id", "name", "onChange", "placeholder", "value"]);

  var onChangeValue = function onChangeValue(e) {
    onChange && onChange(e.target.value);
  };
  /*
   * React will consider the textarea as controlled even if value is null.
   */


  var finalValue = value === null ? undefined : value;
  return React.createElement(StyledTextArea, _extends({
    id: id,
    placeholder: placeholder,
    name: name,
    onChange: onChangeValue,
    value: finalValue
  }, rest));
};

TextArea.defaultProps = {
  id: '',
  onChange: null,
  placeholder: '',
  value: undefined
};
TextArea.propTypes = {
  /**
   * The id of the Textarea, which binds the Textarea with the label.
   */
  id: PropTypes.string,

  /**
   * The name of the Textarea, which is used to get the value of the field.
   */
  name: PropTypes.string.isRequired,

  /**
   * The function called on value change.
   */
  onChange: PropTypes.func,

  /**
   * The text by default in the Textarea.
   */
  placeholder: PropTypes.string,

  /**
   * The value of the Textarea.
   */
  value: PropTypes.string
};
/** @component */

var index = styled(TextArea)(_templateObject$1());

export default index;
